import React, { useState } from "react";
import "./Screenshots.css";
import bat from "../assets/bat.png";
import cars from "../assets/cars.png";
import data from "../assets/data.png";

const images = [
  { src: data, alt: "Screenshot data" },
  { src: cars, alt: "Screenshot cars" },
  { src: bat, alt: "Screenshot bat" },
];

function Screenshots() {
  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);

  // Auto-cycle images every 7 seconds
  React.useEffect(() => {
    if (paused) return;
    const timer = setTimeout(() => setIdx((i) => (i + 1) % images.length), 7000);
    return () => clearTimeout(timer);
  }, [idx, paused]);

  // Pause auto-cycling for 8 seconds on user interaction
  const pause = React.useCallback(() => {
    setPaused(true);
    setTimeout(() => setPaused(false), 8000);
  }, []);

  const prev = () => { pause(); setIdx((i) => (i === 0 ? images.length - 1 : i - 1)); };
  const next = () => { pause(); setIdx((i) => (i === images.length - 1 ? 0 : i + 1)); };
  const goTo = (i) => { pause(); setIdx(i); };

  return (
    <div className="screenshots-carousel">
      <div className="screenshots__img-wrapper">
        <img
          src={images[idx].src}
          alt={images[idx].alt}
          className="screenshots__img screenshots__img--main"
        />
        <div className="screenshots__dots">
          {images.map((img, i) => (
            <button
              key={i}
              className={"screenshots__dot" + (i === idx ? " screenshots__dot--active" : "")}
              onClick={() => goTo(i)}
              aria-label={`Go to screenshot ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Screenshots;
